module.exports = __webpack_public_path__ + "img/xp3_valley.e6c1fb95.jpg";